module.exports = __webpack_public_path__ + "media/images/icons/outlined/stop-0e6941fe889f1894ef0af80e68d34bad.svg";